import Swiper from 'swiper';
import {  Autoplay, EffectFade, Thumbs} from 'swiper/modules';

var swiperThumbs = new Swiper(".thumbs", {
  spaceBetween: 10,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
})
var swiperGallery = new Swiper(".sliderGallery", {
  modules: [ Autoplay,EffectFade, Thumbs],
  spaceBetween: 10,
  autoplay: {
    delay: 5000,
  },
  effect: 'fade',
  thumbs: {
    swiper: swiperThumbs,
  },
})

